/**
 * @author Karl Jones
 * @email karljones@live.ie
 * @create date 2022-12-01 13:51:45
 * @modify date 2022-12-01 13:51:45
 * @desc display a navigation bar to users, tailoring it to mobile users and including accessibility controls
 */

import { FC } from 'react';

import SocialAccounts from '../social/SocialAccounts';

// Material-ui
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Router
import { Link, NavLink } from 'react-router-dom';

// Hooks
import { useIsMobile, useDarkModeActive } from '../../../hooks/Utils'


function a11yProps(index: number) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tab-${index}`
    }
}

function TabItem(props: any) {
    return (
        <Tab
            component={Link}
            {...props}
        />
    );
}

function ExtLink(props: any) {
    return (
        <Tab
            component="a"
            {...props}
        />
    );
}

interface IHeader {
    tab: number;
    setTab: (tab: number) => void;
}

const Header: FC<IHeader> = ({ tab, setTab }) => {
    const isMobile = useIsMobile();
    const darkModeActive = useDarkModeActive();

    const handleChange = (event: any, newValue: number) => {
        setTab(newValue);
    }

    return (
        <div data-testid="header" className="Header--container">

            <img
                className="Header--banner-image"
                src={
                    darkModeActive
                        ? 'https://ucarecdn.com/95dc0552-0705-4672-b9c7-65acf972a9f3/-/preview/-/quality/smart/-/format/webp/'
                        : 'https://ucarecdn.com/25468194-afee-4f50-8b66-d8acbcdf8ad6/-/preview/-/quality/smart/-/format/webp/'
                }
                alt="Website title 'Paige Hart'" />

            <SocialAccounts />

            {isMobile &&
                <Tabs
                    value={tab}
                    onChange={handleChange}
                    aria-label="scrollable navigation tabs"
                    scrollButtons
                    allowScrollButtonsMobile
                    variant="scrollable">
                    <TabItem label="Home" to="/" {...a11yProps(0)} />
                    <TabItem label="Books" to="/books" {...a11yProps(1)} />
                    <TabItem label="Podcast" to="/podcast" {...a11yProps(2)} />
                    <TabItem label="Blog" to="/blog" {...a11yProps(3)} />
                    <ExtLink label="Etsy Shop" href="https://www.etsy.com/uk/shop/The2littlebugs?ref=paigehart-site-navigation" target="_blank" {...a11yProps(4)} />
                    <TabItem label="Contact" to="/contact" {...a11yProps(5)} />
                </Tabs>
            }
            {!isMobile &&
                <Tabs
                    value={tab}
                    onChange={handleChange}
                    aria-label="navigation tabs"
                    centered>
                    <TabItem label="Home" to="/" {...a11yProps(0)} />
                    <TabItem label="Books" to="/books" {...a11yProps(1)} />
                    <TabItem label="Podcast" to="/podcast" {...a11yProps(2)} />
                    <TabItem label="Blog" to="/blog" {...a11yProps(3)} />
                    <ExtLink label="Etsy Shop" href="https://www.etsy.com/uk/shop/The2littlebugs?ref=paigehart-site-navigation" target="_blank" {...a11yProps(4)} />
                    <TabItem label="Contact" to="/contact" {...a11yProps(5)} />
                </Tabs>
            }
        </div>
    )
}

export default Header;